type SizeUnit = 'px';

const SIZE_UNIT: SizeUnit = 'px';

const FONT_WEIGHTS = {
  bold: '700',
  semibold: '600',
  medium: '500',
  regular: '400',
};

const LINE_HEIGHT = {
  display: 48,
  h1: 36,
  h2: 32,
  h3: 29,
  sub: 22,
  p1: 24,
  p2: 22,
  p3: 22,
  p4: 21,
  caption: 20,
};

function getTypographyStyle(
  fontSize: number,
  fontWeight: keyof typeof FONT_WEIGHTS,
  lineHeight?: keyof typeof LINE_HEIGHT,
) {
  return {
    fontSize,
    lineHeight: lineHeight ? LINE_HEIGHT[lineHeight] + SIZE_UNIT : undefined,
    fontWeight: FONT_WEIGHTS[fontWeight],
  };
}

export default getTypographyStyle;
